import { useState } from 'react';
import { useI18n } from '../i18n';
import { Icon } from './icons';

/**
 * Löschen in zwei Schritten: erst „Löschen“ (bzw. Papierkorb-Symbol in Tabellenzeilen), dann „Wirklich löschen?“.
 * Klicks gehen nicht an die Tabellenzeile weiter (die sonst die Bearbeitung öffnet).
 */
export function DeleteButton({ onDelete, what, confirmText, compact, disabled, title }: {
  onDelete: () => Promise<unknown>; what: string; confirmText?: string; compact?: boolean; disabled?: boolean; title?: string;
}) {
  const { t } = useI18n();
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();

  async function go(e: React.MouseEvent) {
    stop(e);
    setBusy(true);
    try { await onDelete(); } finally { setBusy(false); setConfirm(false); }
  }

  if (confirm) {
    return (
      <span className="delconfirm" onClick={stop} onKeyDown={stop}>
        {/* In Tabellenzeilen kurz halten; der ausführliche Hinweis steht dann im Tooltip */}
        <button className="btn danger" onClick={go} disabled={busy} autoFocus title={compact ? confirmText : undefined}>{busy ? t('common.archiving') : compact ? (confirmText ? t('del.short') : t('common.archiveConfirm')) : confirmText ?? t('common.archiveConfirm')}</button>
        <button className="btn ghost" onClick={(e) => { stop(e); setConfirm(false); }} disabled={busy}>{t('common.cancel')}</button>
      </span>
    );
  }
  return compact
    ? <button className="iconbtn delbtn" aria-label={t('del.row', { n: what })} title={title ?? t('del.row', { n: what })} disabled={disabled} onClick={(e) => { stop(e); setConfirm(true); }} onKeyDown={stop}>{Icon.trash}</button>
    : <button className="btn danger" title={title} disabled={disabled} onClick={(e) => { stop(e); setConfirm(true); }}>{t('common.archive')}</button>;
}
